import React from 'react'
import Grid from '@material-ui/core/Grid/Grid'
import ButtonBase from '@material-ui/core/ButtonBase/ButtonBase'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme =>({
    btn: {
        padding: 4,
        borderRadius: 4,
        color: theme.palette.primary.dark,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff'
        },
    },
})

const MyIconButton = ({ icon, disabled, iconRight, label, onTap, classes }) => (
    <ButtonBase disabled={disabled} className={classes.btn} onClick={onTap}>
        <Grid alignItems="center" container>
            {
                icon && 
            <Grid className={classes.icon} item>{icon}</Grid>
            }
            <Grid item>{label}</Grid>
            {
                iconRight && 
            <Grid className={classes.icon} item>{iconRight}</Grid>
            }
        </Grid>
    </ButtonBase>
)

export default withStyles(styles)(MyIconButton)
